export const impersonateTypes = {
    GET_ALL_IMPERSONATE_USERS: "GET_ALL_IMPERSONATE_USERS",
}
